import { render, staticRenderFns } from "./shsq.vue?vue&type=template&id=5170a7f8&scoped=true&"
import script from "./shsq.vue?vue&type=script&lang=js&"
export * from "./shsq.vue?vue&type=script&lang=js&"
import style0 from "./shsq.vue?vue&type=style&index=0&id=5170a7f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5170a7f8",
  null
  
)

export default component.exports